import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"
import cacheLs from "../cacheLs"

const state = {
  selectedDeepLink: cacheLs.get_deep_link()
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
